import {
  KpiCard,
  KpiEntityName,
  Link,
  JustLineChart,
  KpiSkeleton
} from '@/components';
import { useCirculatingSupply, useCirculatingSupplyHistoric } from '@/api';
import { tokensMapping } from '@/utils/tokens';
import { CryptoIcon, LinkWrapper, useIsMobile } from '@blockanalitica/ui';

const chartConfig = {
  options: {
    fill: false,
    maintainAspectRatio: false,
    elements: {
      line: {
        borderWidth: 5
      }
    },
    plugins: {
      tooltip: {
        enabled: false
      }
    }
  },
  plugins: [
    {
      id: 'responsiveGradient',
      beforeDatasetsDraw(chart) {
        const {
          ctx,
          chartArea: { left, right }
        } = chart;
        const gradient = ctx.createLinearGradient(left, 0, right, 0);
        gradient.addColorStop(0, 'rgba(25, 211, 180, 0.1)');
        gradient.addColorStop(1, 'rgba(25, 211, 180, 1)');
        chart.data.datasets[0].borderColor = gradient;
      }
    }
  ]
};

export default function TotalSupplyKpi({ daysAgo }) {
  const isMobile = useIsMobile();
  const [data, error] = useCirculatingSupply(daysAgo);
  const [chartData] = useCirculatingSupplyHistoric('30');

  if (error) {
    throw error;
  }

  if (data && chartData) {
    return (
      <LinkWrapper
        to="supply"
        // @ts-ignore
        as={Link}
        variant="kpiCardLinkWithBlendMode">
        <KpiCard
          title="Total Supply"
          variant="usds"
          field="total_circulating"
          data={data}
          options={{
            linkArrow: true,
            notation: isMobile ? 'compact' : 'standard',
            prefixIcon: (
              <KpiEntityName
                symbol2={<CryptoIcon name="DAI" size="4" />}
                symbol1={
                  <CryptoIcon
                    name="USDS"
                    address={tokensMapping('USDS').address}
                    size="4"
                  />
                }></KpiEntityName>
            ),
            variants: {
              kpiCardValue: 'singleTitle',
              kpiCardFooter: 'singleTitle',
              kpiHeader: 'singleTitle'
            },
            chart: (
              <JustLineChart
                data={chartData}
                datasets={[
                  {
                    xField: 'date',
                    yField: 'total_circulating'
                  }
                ]}
                config={chartConfig}
              />
            )
          }}
        />
      </LinkWrapper>
    );
  }

  return <KpiSkeleton />;
}
